import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlypickanddropservicepune() {



  const cardData =
  {
    keyword: 'Monthly Pick and Drop Service Pune',
    heading: 'Pune Corporate Cars India Private Limited: Monthly Pick and Drop Service Pune',
    headingDescription: ' Pune Corporate Cars India Private Limited provides dependable and cost-effective Monthly Pick and Drop Service in Pune, designed for employees, corporate teams, and businesses that require consistent, timely daily transportation. Our fleet of clean, fully air-conditioned sedans, hatchbacks, and SUVs ensures a comfortable commute every day. With trained chauffeurs, fixed monthly plans, and punctual service, we make daily office travel smooth and stress-free. Whether your company needs individual pick-and-drop, group employee transport, or dedicated monthly cabs, Pune Corporate Cars India Private Limited delivers safe, reliable, and professionally managed mobility solutions tailored to your daily travel needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Monthly Employee Shuttle Pune",
    "description": "Monthly Employee Shuttle Pune provides reliable, timely, and well-organized transportation for companies requiring daily group commuting. With AC minibuses, tempo travellers, and shuttle vans, we ensure smooth travel across major corporate zones. Our monthly plans include fixed routes, shift-based operations, verified chauffeurs, and GPS-enabled vehicles. Monthly Employee Shuttle Pune enhances employee convenience, reduces lateness, and ensures safe, consistent mobility for the entire workforce."
  },
  {
    "name": "Office Pickup Drop Monthly Pune",
    "description": "Office Pickup Drop Monthly Pune offers structured, punctual, and cost-efficient office commute services for employees across Pune. Companies receive fixed schedules, sanitized vehicles, and professional drivers to manage daily pickup and drop. Ideal for IT parks, corporate offices, and industrial zones, this service ensures employees reach work safely and on time every day. Office Pickup Drop Monthly Pune is the perfect long-term transport solution for corporate teams."
  },
  {
    "name": "Monthly Staff Transport Pune",
    "description": "Monthly Staff Transport Pune delivers dependable daily commuting solutions for employees working in different shifts and locations. We operate multiple-route transport with clean, AC vehicles and trained chauffeurs. Companies benefit from predictable billing, optimized routes, and priority support. Whether for early-morning shifts, night travel, or regular commuting, Monthly Staff Transport Pune ensures seamless and secure mobility for organizations."
  },
  {
    "name": "Pune Corporate Pick Drop",
    "description": "Pune Corporate Pick Drop provides companies with professional pickup and drop services for their staff and executives. Our vehicles are equipped with AC, comfortable seating, and GPS tracking for safe travel. With scheduled routes, disciplined chauffeurs, and corporate-grade service, we help businesses reduce employee travel stress and improve punctuality. Pune Corporate Pick Drop is ideal for companies seeking consistent and dependable daily transportation."
  },
  {
    "name": "Business Cab Monthly Hire Pune",
    "description": "Business Cab Monthly Hire Pune offers dedicated cabs assigned to your organization for daily business travel, meetings, and staff mobility. Vehicles include sedans and SUVs operated by trained chauffeurs. Companies enjoy fixed monthly billing, priority vehicle replacement, and reliable service every day. Business Cab Monthly Hire Pune ensures uninterrupted, premium mobility tailored for business needs."
  },
  {
    "name": "Employee Home Pickup Service",
    "description": "Employee Home Pickup Service ensures safe, comfortable, and timely pickup from employee residences across Pune. Perfect for companies with shift-based operations, BPOs, IT parks, and industrial units. Our verified chauffeurs, clean vehicles, and route planning guarantee punctual and secure staff travel. Employee Home Pickup Service supports workforce convenience and contributes to improved attendance and productivity."
  },
  {
    "name": "Pune Office Commute Monthly",
    "description": "Pune Office Commute Monthly offers a month-long commuting plan designed for employees traveling daily to their offices. The service includes non-stop availability of AC cars, trained chauffeurs, and predictable billing. Whether for individual executives or staff teams, our monthly packages are tailored for convenience, comfort, and reliability. Pune Office Commute Monthly ensures stress-free and punctual daily travel."
  },
  {
    "name": "Monthly Fleet for Companies",
    "description": "Monthly Fleet for Companies provides multiple vehicles—sedans, SUVs, vans, and tempo travellers—assigned exclusively to your business for long-term use. We manage vehicle maintenance, driver allocation, route scheduling, and timely replacements. Ideal for organizations with high transportation demands. Monthly Fleet for Companies ensures centralized, efficient, and cost-effective mobility management."
  },
  {
    "name": "Best Monthly Cab Pickup Drop Pune",
    "description": "Best Monthly Cab Pickup Drop Pune offers top-rated transportation with professional drivers, sanitized AC cars, and punctual service. Companies can rely on dedicated cabs for daily staff movement and office-to-office transfers. Our monthly plans provide transparent billing, zero surge charges, and reliable availability. Best Monthly Cab Pickup Drop Pune ensures smooth and consistent daily commuting for all corporate teams."
  },
  {
    "name": "Affordable Monthly Shuttle Pune",
    "description": "Affordable Monthly Shuttle Pune is a budget-friendly option for companies looking to manage employee transportation without compromising safety or comfort. Our AC shuttles, minibuses, and tempo travellers run on optimized routes designed to reduce costs and improve efficiency. With fixed monthly pricing and dependable service, Affordable Monthly Shuttle Pune is perfect for startups and growing organizations."
  },
  {
    "name": "IT Company Pickup Drop Pune",
    "description": "IT Company Pickup Drop Pune provides structured transportation specifically for IT firms operating in Hinjewadi, Kharadi, Magarpatta, and other tech hubs. We manage multi-route scheduling, verified drivers, real-time tracking, and night shift safety compliance. With clean vehicles and professional operations, IT Company Pickup Drop Pune ensures smooth daily mobility for IT employees."
  },
  {
    "name": "Corporate Staff Commute Pune",
    "description": "Corporate Staff Commute Pune offers reliable and efficient commuting solutions for staff across all industries. Our service focuses on safety, punctuality, and comfort, with AC vehicles and trained chauffeurs assigned to daily routes. Ideal for organizations with shift patterns, large teams, or multi-location operations. Corporate Staff Commute Pune guarantees dependable and well-managed daily travel."
  },
  {
    "name": "Monthly Sedan Cab Pune",
    "description": "Monthly Sedan Cab Pune provides comfortable and professional sedans ideal for executives, managers, and daily office travelers. Vehicles such as Dzire, Etios, and Honda City offer smooth rides and premium comfort. Our monthly plans include dedicated drivers, predictable billing, and priority customer support. Monthly Sedan Cab Pune ensures professional and consistent daily commutes."
  },
  {
    "name": "Monthly SUV Cab Pune",
    "description": "Monthly SUV Cab Pune offers spacious and comfortable SUVs like Ertiga, Innova, and Crysta for long-term corporate travel requirements. SUVs provide extra legroom, superior suspension, and higher comfort levels for long routes and group travel. Ideal for executive teams and field operations, Monthly SUV Cab Pune ensures reliable and premium monthly mobility."
  },
  {
    "name": "Employee Transportation Contract Pune",
    "description": "Employee Transportation Contract Pune provides long-term, contract-based transportation management for companies with continuous mobility needs. We handle fleet assignment, driver management, route scheduling, maintenance, and replacements. Perfect for IT firms, industrial units, corporate parks, and manufacturing companies. Employee Transportation Contract Pune ensures fully-managed, cost-efficient, and seamless employee mobility."
  }
],
"tableData": [
  ["Monthly Employee Shuttle Pune", "Office Pickup Drop Monthly Pune"],
  ["Monthly Staff Transport Pune", "Pune Corporate Pick Drop"],
  ["Business Cab Monthly Hire Pune", "Employee Home Pickup Service"],
  ["Pune Office Commute Monthly", "Monthly Fleet for Companies"],
  ["Best Monthly Cab Pickup Drop Pune", "Affordable Monthly Shuttle Pune"],
  ["IT Company Pickup Drop Pune", "Corporate Staff Commute Pune"],
  ["Monthly Sedan Cab Pune", "Monthly SUV Cab Pune"],
  ["Employee Transportation Contract Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Monthly Pick and Drop Service Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable and affordable monthly pick and drop services in Pune, ideal for regular office commute and long-term travel needs."
  },
  {
    "WhyChooseheading": "Cost-Effective Monthly Plans",
    "WhyChoosedescription": "Our monthly packages are designed to provide consistent and reliable transportation at budget-friendly rates with no hidden fees."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our vehicles are well-maintained, sanitized, and equipped to ensure a safe, comfortable, and smooth daily commute."
  },
  {
    "WhyChooseheading": "Punctual Daily Pickups and Drops",
    "WhyChoosedescription": "We ensure timely pickup and drop services tailored to your office hours and personal schedules."
  },
  {
    "WhyChooseheading": "Flexible Travel Timings",
    "WhyChoosedescription": "Customize your pickup and drop timings according to your work schedule, with complete flexibility for monthly travel."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe driving, punctuality, and a pleasant commute experience throughout the month."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with schedule changes, emergency requests, and travel coordination."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your monthly pick and drop service easily through our online portal or via phone, with fast confirmations and reliable service."
  }
]





















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer monthly pick and drop service in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and affordable monthly pick and drop services across Pune for office commute and regular travel needs.',
  },
  {
    question: 'How can I book a monthly pick and drop service in Pune?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What vehicles are available for monthly pick and drop service?',
    answer: 'We offer hatchbacks, sedans, SUVs, and premium vehicles suitable for daily pick and drop requirements.',
  },
  {
    question: 'Are the drivers trained for regular monthly commute services?',
    answer: 'Yes, all our drivers are trained, punctual, and experienced in handling regular office commute routes.',
  },
  {
    question: 'Can I customize the monthly pick and drop package?',
    answer: 'Absolutely. We provide flexible monthly packages based on distance, timing, vehicle preference, and frequency.',
  },
  {
    question: 'Is the monthly pick and drop service available 24×7 in Pune?',
    answer: 'Yes, our services are available round-the-clock to suit your work shifts and travel schedules.',
  },
  {
    question: 'What safety measures are followed for monthly pick and drop cabs?',
    answer: 'All vehicles are sanitized regularly and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are available for monthly pick and drop services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and monthly invoicing.',
  },
  {
    question: 'Is customer support available throughout the monthly service?',
    answer: 'Yes, our dedicated support team is available 24×7 to assist you throughout your service period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshad Bhagat',
    feedback: 'The monthly pick and drop service by Pune Corporate Cars India Private Limited is extremely reliable. The driver is always punctual and the ride is comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavya Mane',
    feedback: 'Very satisfied with their monthly commute service. Clean cars, smooth coordination, and professional drivers. Highly recommended!',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Pick and Drop Service Pune",
  "image": "https://www.punecorporatecars.com/assets/images/monthly-pick-drop-pune.jpg", // replace with actual image URL
  "description": "Reliable monthly pick and drop services in Pune for corporate employees. Pune Corporate Cars India Private Limited offers office and home commute solutions, employee shuttles, monthly fleet management, and chauffeur-driven sedans and SUVs for businesses and IT companies.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000", // monthly starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/monthly-pick-drop-service-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Monthly Pick and Drop Service Pune | Employee Shuttle & Office Commute | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable monthly pick and drop services in Pune for corporate employees. Chauffeur-driven sedans and SUVs, office and home commute solutions, employee shuttles, and monthly fleet management by Pune Corporate Cars India Private Limited."
  />

  <meta
    name="keywords"
    content="Monthly Employee Shuttle Pune, Office Pickup Drop Monthly Pune, Monthly Staff Transport Pune, Pune Corporate Pick Drop, Business Cab Monthly Hire Pune, Employee Home Pickup Service, Pune Office Commute Monthly, Monthly Fleet for Companies, Best Monthly Cab Pickup Drop Pune, Affordable Monthly Shuttle Pune, IT Company Pickup Drop Pune, Corporate Staff Commute Pune, Monthly Sedan Cab Pune, Monthly SUV Cab Pune, Employee Transportation Contract Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlypickanddropservicepune;